(function() {
    'use strict';

    angular
        .module('app')
        .directive('inputFocus', inputFocus);

    inputFocus.$inject = ['$timeout'];
    
    function inputFocus($timeout) {
        // Usage:
        //     <inputFocus></inputFocus>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                editable: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch(function () {
                return scope.editable;
            }, function (value) {
                if (value) {
                    $timeout(function () {
                        element[0].focus();
                        
                    }, 50);   
                    $timeout(function () {
                        element[0].select();
                    }, 200);
                }
            })

        }
    }

})();